/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { EvmWallet } from './EvmWallet';
import {
    EvmWalletFromJSON,
    EvmWalletFromJSONTyped,
    EvmWalletToJSON,
    EvmWalletToJSONTyped,
} from './EvmWallet';

/**
 * 
 * @export
 * @interface GetUserResponse
 */
export interface GetUserResponse {
    /**
     * 
     * @type {User}
     * @memberof GetUserResponse
     */
    user: User;
    /**
     * 
     * @type {Array<EvmWallet>}
     * @memberof GetUserResponse
     */
    wallets: Array<EvmWallet>;
    /**
     * Request-context only: the ISO country detected server-side (cf-ipcountry) for THIS request. Populated by GET /users/profile so the client can compare the account's captured consent jurisdiction against where the user is right now. Absent on admin GET /users/{id}.
     * @type {string}
     * @memberof GetUserResponse
     */
    currentCountry?: string;
}

/**
 * Check if a given object implements the GetUserResponse interface.
 */
export function instanceOfGetUserResponse(value: object): value is GetUserResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('wallets' in value) || value['wallets'] === undefined) return false;
    return true;
}

export function GetUserResponseFromJSON(json: any): GetUserResponse {
    return GetUserResponseFromJSONTyped(json, false);
}

export function GetUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
        'wallets': ((json['wallets'] as Array<any>).map(EvmWalletFromJSON)),
        'currentCountry': json['currentCountry'] == null ? undefined : json['currentCountry'],
    };
}

export function GetUserResponseToJSON(json: any): GetUserResponse {
    return GetUserResponseToJSONTyped(json, false);
}

export function GetUserResponseToJSONTyped(value?: GetUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserToJSON(value['user']),
        'wallets': ((value['wallets'] as Array<any>).map(EvmWalletToJSON)),
        'currentCountry': value['currentCountry'],
    };
}

